(() => {
  'use strict';

  function initForm(root) {
    const dataEl = root.querySelector('[data-product-json]');
    if (!dataEl) return;
    const product = JSON.parse(dataEl.textContent);
    const optionInputs = Array.from(root.querySelectorAll('[data-option-input]'));
    const variantIdInput = root.querySelector('[data-variant-id-input]');
    // All of these are now rendered twice — once in the page, once in the sticky mobile buy
    // bar — so every one is a NodeList. A single querySelector here would have left the bar
    // showing the first variant's price forever, which is worse than showing none.
    const priceEls = root.querySelectorAll('[data-price-display]');
    const submitBtns = root.querySelectorAll('[data-add-to-cart-button]');
    const specOptionsEls = root.querySelectorAll('[data-spec-options]');
    const specJoinedEls = root.querySelectorAll('[data-spec-joined]');
    // The gallery lives outside the form element, so it is looked up from the document.
    const mainImageBox = document.querySelector('[data-main-image]');
    const mainImage = mainImageBox && mainImageBox.querySelector('img');
    const thumbs = Array.from(document.querySelectorAll('[data-gallery-thumb]'));

    function findVariant(selected) {
      return product.variants.find((v) => {
        return selected.every((val, i) => (val == null) || v.options[i] === val);
      });
    }

    function currentSelection() {
      const byIndex = {};
      optionInputs.forEach((input) => {
        if (input.type === 'radio' && !input.checked) return;
        byIndex[Number(input.dataset.optionIndex)] = input.value;
      });
      const max = Math.max(0, ...optionInputs.map((i) => Number(i.dataset.optionIndex) + 1));
      const selected = [];
      for (let i = 0; i < max; i++) selected.push(byIndex[i] ?? null);
      return selected;
    }

    function formatMoney(cents) {
      return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: product.currency || 'EUR' });
    }

    // Swapping the picture is as much a part of the variant change as swapping the price.
    // A framed poster has one mockup per size: leaving the 12x18 mockup on screen while the
    // price reads the 24x36 figure misrepresents what is in the basket. The aspect ratio
    // moves with it, because the three mockups are not the same shape and a fixed box would
    // crop whichever one it was not drawn for.
    function showImage(src, ratio, alt, imageId) {
      if (!mainImage || !src || mainImage.getAttribute('src') === src) {
        markThumb(imageId);
        return;
      }
      mainImage.setAttribute('src', src);
      mainImage.removeAttribute('srcset');
      if (alt) mainImage.setAttribute('alt', alt);
      if (ratio) mainImageBox.style.aspectRatio = String(ratio);
      markThumb(imageId);
    }

    function markThumb(imageId) {
      if (!thumbs.length) return;
      thumbs.forEach((t) => {
        const on = imageId != null && String(t.dataset.imageId) === String(imageId);
        if (on) t.setAttribute('aria-current', 'true');
        else t.removeAttribute('aria-current');
      });
    }

    // Clicking a thumb is a plain gallery action and must not pretend a variant changed,
    // so it moves the picture and the marker and leaves the price and the picker alone.
    thumbs.forEach((t) => {
      t.addEventListener('click', () => {
        showImage(t.dataset.full, t.dataset.ratio, t.dataset.alt, t.dataset.imageId);
      });
    });

    function update() {
      const variant = findVariant(currentSelection());
      optionInputs.forEach((input) => {
        if (input.type !== 'radio') return;
        const group = root.querySelectorAll(`[data-option-index="${input.dataset.optionIndex}"]`);
        group.forEach((el) => el.closest('[data-option-pill]')?.classList.toggle('is-selected', el.checked));
      });
      if (!variant) {
        submitBtns.forEach((btn) => { btn.disabled = true; btn.textContent = btn.dataset.unavailableLabel || 'Unavailable'; });
        return;
      }
      if (variantIdInput) variantIdInput.value = variant.id;
      // Shopify gives single-variant products a synthetic option whose only value is
      // "Default Title". The Liquid skips it, so this has to skip it too — otherwise the
      // script writes it straight back into the spec line the moment the page loads.
      const options = product.hasOnlyDefaultVariant
        ? []
        : variant.options.map((o) => String(o).toUpperCase());
      showImage(variant.image, variant.imageRatio, variant.imageAlt, variant.imageId);
      priceEls.forEach((el) => { el.textContent = formatMoney(variant.price); });
      specOptionsEls.forEach((el) => { el.textContent = options.map((o) => ' · ' + o).join(''); });
      specJoinedEls.forEach((el) => { el.textContent = options.join(' · '); });
      submitBtns.forEach((btn) => {
        btn.disabled = !variant.available;
        btn.textContent = variant.available
          ? (btn.dataset.addLabel || 'Add to Cart')
          : (btn.dataset.soldoutLabel || 'Sold Out');
      });
    }

    optionInputs.forEach((input) => input.addEventListener('change', update));
    update();
  }

  document.querySelectorAll('[data-meningea-product-form]').forEach(initForm);
})();
